export default __webpack_public_path__ + "static/media/Goshoppi1.980655b5.png";